import Image from 'core/image';
import insuranceLogoMapper from 'utils/insurance-logo-mapper/insurance-logo-mapper';
import PropTypes from 'prop-types';
import styles from 'styles/LandingSelectorInsuranceTable.module.scss';

const SelectorItem = ({ companyName, companyCode, culture, href }) => {
    if (!companyName) {
        return null;
    }

    return (
        <a href={href} target="_blank" rel="noreferrer">
            <div className={styles.item}>
                <Image
                    src={insuranceLogoMapper(companyCode, culture, 'colored')}
                    alt={`${companyName} Logo`}
                    width={180}
                    height={60}
                />
                <p>{companyName}</p>
            </div>
        </a>
    );
};

SelectorItem.propTypes = {
    href: PropTypes.string,
    companyName: PropTypes.string,
    companyCode: PropTypes.string,
    culture: PropTypes.string
};

export default SelectorItem;
